import * as React from "react";
import {Helmet} from "react-helmet";

const Head = () => {
  return (
    <Helmet>
      <link
        href="https://spoqa.github.io/spoqa-han-sans/css/SpoqaHanSans-kr.css"
        rel="stylesheet"
      />
      <link
        href="https://fonts.googleapis.com/earlyaccess/jejugothic.css"
        rel="stylesheet"
      />
    </Helmet>
  );
};

export default Head;
